import { render, staticRenderFns } from "./creating.vue?vue&type=template&id=47ed4d81&scoped=true"
import script from "./creating.vue?vue&type=script&lang=js"
export * from "./creating.vue?vue&type=script&lang=js"
import style0 from "./creating.vue?vue&type=style&index=0&id=47ed4d81&prod&lang=less&scoped=true"
import style1 from "./creating.vue?vue&type=style&index=1&id=47ed4d81&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ed4d81",
  null
  
)

export default component.exports